// extracted by css-extract-rspack-plugin
export default {"header":"DonationInsights_header__pX7b5","titleGroup":"DonationInsights_titleGroup__F0WJE"};